module.exports = __webpack_public_path__ + "static/media/BoxPlotQ5_1.bce5a54f.svg";